import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { makeElementId } from '../../../Common/Utilties/LaborUtility'

import DailyTableRow from './DailyTableRow'

const DailyTableBody = ({
    register, getValues, setValue, watch, reset, errors,
    defaultUrl, workInfoList,workDivisions
  }) => {

  return (
    <tbody>
      {workInfoList && workInfoList.map((workInfo) => {
        return (
          <DailyTableRow key={"top_" + makeElementId(workInfo)}
            register={register}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
            reset={reset}
            errors={errors}
            workDivisions={workDivisions}
            defaultUrl={defaultUrl}
            workInfo={workInfo}
          >
          </DailyTableRow>
        )
      })}
    </tbody>
  )
}

DailyTableBody.propTypes = {
  register: PropTypes.func,
  setValue: PropTypes.func,
  getValues: PropTypes.func,
  watch: PropTypes.func,
  reset: PropTypes.func,
  errors: PropTypes.object,

  defaultUrl: PropTypes.string,
  workInfoList: PropTypes.array
}

export default DailyTableBody
